import questionCrown from "../../../assets/icons/questionCrown.svg";
import { FC, useContext } from "react";
import { TeamContext, UserContext } from "../../../context";
import { IPlayer } from "../../../interfaces";
import instructionArrow from "../../../assets/icons/instructionArrow.svg";

interface IDilemmaOwnerAnouncementText {
    upperText: string;
    lowerText?: string;
    componentStyle?: "dilemma" | "default";
    middleText?: string;
    isArrowShown?: boolean;
    isArrowShownTextBig?: boolean;
}

const DilemmaOwnerAnouncementText: FC<IDilemmaOwnerAnouncementText> = ({upperText, lowerText, componentStyle, middleText, isArrowShown, isArrowShownTextBig}) => {
    const { game } = useContext(TeamContext);
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    const dilemmaOwnerEmail = dilemmaOwner?.email || "";


    const userColor = () => {
        if (dilemmaOwner) return game?.gameInfo.players[dilemmaOwnerEmail].color || 0;

        return game?.players?.find((player: any) => { return player.email === dilemmaOwnerEmail})?.color || "";
    }

    const getStyle = () => {
        if (!componentStyle) componentStyle = "default";
        return dicitonary[componentStyle];
    }

    const dicitonary = {
        dilemma: "dilemma_owner_anouncement_centering",
        default: "center_horizontally_and_vertically full_screen_vw_vh0"
    }

    return (
        <div className={`dilemma_owner_anouncement ${getStyle()} `} >
            <div className="dilemma_owner_anouncement_context">
                <div className="dilemma_owner_anouncement_icon_and_image">
                    <img
                        className="question_crown"
                        src={questionCrown}
                        alt="Profile Icon"
                    />
                    <img
                        className={`profile_image border_color_${userColor()} `}
                        src={`${process.env.REACT_APP_BACKEND_URL}images/${dilemmaOwner?.email}.png`}
                        alt="Profile Icon"
                    />
                </div>
                <div className="dilemma_owner_anouncement_text">
                    <div className="dilemma_owner_anouncement_text_big"> {upperText} </div>
                    <div className="dilemma_owner_anouncement_text_big display_flex"> 
                        <div> {middleText} </div>
                        {isArrowShownTextBig && <div className="margin_left_10 bracet">(</div>}
                        {isArrowShownTextBig && <img src={instructionArrow} alt="instructionArrow" />}
                        {isArrowShownTextBig && <div className="bracet">)</div>}
                    </div>
                    {lowerText && 
                        <div className="dilemma_owner_anouncement_text_small"> 
                            <div className="center_vertically">{lowerText}</div> 
                            {isArrowShown && <div className="margin_left_10 bracet">(</div>}
                            {isArrowShown && <img src={instructionArrow} alt="instructionArrow" />}
                            {isArrowShown && <div className="bracet">)</div>}
                        </div>}
                </div>
            </div>
            <div className="gradient_line_holder center_horizontally_and_vertically" style={{width: "100%"}}>
                <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
            </div>
        </div>        
    )
}

export default DilemmaOwnerAnouncementText;